import dutyApi from '@/store/dutyApi'
import { Auth } from 'aws-amplify'

const user = {
  state: {
    roster: null
  },
  mutations: {
    setRoster: function (state, data) {
      state.roster = data
    }
  },
  actions: {
    loadRoster: async function (context) {
      console.log('Loading Duty Roster...')
      context.commit('setRoster', null)
      let response = await dutyApi.loadRoster()
      console.log(response)
      if (!response.error && response.roster !== undefined) {
        console.log('Roster Retrieved!')
        console.log(response.roster)
        console.log('*** ROSTER LOADED ***')
        context.commit('setRoster', response.roster)
        return response.roster
      }

      console.log('GetRoster Error')
      console.log(response.error)
    },
    updateRosterStore: async function (context, args) {
      const { timestamp, isSelected } = args

      console.log('TRACK DUTY STORE: UPDATING ROSTER DATA')
      console.log('DATE TO UPDATE: ', timestamp)
      console.log('Was this date already selected? ', isSelected)

      const date = new Date(timestamp)
      const y = `${date.getFullYear()}`
      const m = `${date.getMonth()}`
      const d = `${date.getDate()}`

      const roster = context.state.roster

      if (!roster[y]) roster[y] = {}
      if (!roster[y][m]) roster[y][m] = {}
      if (!roster[y][m][d]) {
        roster[y][m][d] = {
          supervisor: null,
          volunteers: []
        }
      }

      const rosterDay = roster[y][m][d]

      if (rosterDay.volunteers.length >= 3 && !isSelected) {
        console.log('MAX Volunteers; Cant add more')
        return false
      }

      const user = await Auth.currentAuthenticatedUser()
      const volunteer = {
        id: user.attributes.sub,
        name: `${user.attributes.given_name} ${user.attributes.family_name}`,
        isCommittee: (user.attributes['custom:capabilities'] && user.attributes['custom:capabilities'].indexOf('committee') >= 0)
      }

      console.log('Existing Roster:', rosterDay.volunteers)
      
      let volunteers = []
      rosterDay.volunteers.map((member, ix) => {
        if (member.id !== volunteer.id) volunteers.push(member)
      })

      if (!isSelected) volunteers.push(volunteer)

      rosterDay.volunteers = volunteers
      roster[y][m][d] = rosterDay

      console.log('Updated roster: ', rosterDay.volunteers)
      console.log('COMMITTING ROSTER TO STORE')
      context.commit('setRoster', roster)
      return rosterDay
    },
    updateRosterDay: async function (context, args) {
      try {
        console.log('*** DUTY STORE - Update Day Roster ***')
        console.log(args)
        console.log('Updating Backend...')
        const response = await dutyApi.updateRoster(args)
        if (response.error !== undefined) {
          console.log('Update Day Roster Response Error')
          console.log(response.error)
          return response
        }

        console.log('Backend Roster Updated!')
        console.log(response)

        const roster = context.state.roster
        if (!roster[args.year]) roster[args.year] = {}
        if (!roster[args.year][args.month]) roster[args.year][args.month] = {}
        if (!roster[args.year][args.month][args.day]) {
          roster[args.year][args.month][args.day] = {
            supervisor: null,
            volunteers: []
          }
        }

        roster[args.year][args.month][args.day] = args.roster
        context.commit('setRoster', roster)
        return args.roster
      } catch (e) {
        console.log('Update Day Roster Catch Error')
        console.log(e)
        return {
          error: true,
          message: e.message
        }
      }
    },
    getRosterMonth: function (context, args) {
      if (context.state.roster === null) return {}
      const year = args.year
      const month = args.month
      if (context.state.roster &&
        context.state.roster[year] &&
        context.state.roster[year][month]
      ) {
        return context.state.roster[year][month]
      }
      return {}
    }
  },
  getters: {
    getRoster: function (state) {
      return state.roster
    },
    isRosterLoaded: function (state) {
      return (state.roster !== undefined && state.roster)
    }
  }
}

export default user
